// extracted by mini-css-extract-plugin
module.exports = {"button":"back-to-top_button__msdG4","active":"back-to-top_active__Kt7zt"};